window.$ = window.jQuery = require('jquery');
// window.select2 = require('select2');
window.owlCarousel = require('owl.carousel');

import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/modal';
window.Modal = require('bootstrap/js/dist/modal');
import './cookie';
import './menu';
import './mds-qty';
import './keen-slider';
import './custom';
